<div class="col" style="margin-top: 32px; text-align: right">
  <div tooltip="Volume [g/L]" style="display: inline-block">
    <div style="display: inline-block; margin-right: 8px">
      <img src="assets/cube.png" alt="axis" width="26px" height="26px" />
    </div>

    <div style="display: inline-block; margin-right: 25px">
      <p>{{ mesh.volume | number : '1.3-3' }}</p>
    </div>
  </div>

  <!-- <div  tooltip="Gravity vector (x,y,z)" style="display: inline-block">
        <div style="display: inline-block;margin-right: 5px;">
            <img src="assets/axis_round.png" alt="axis" width="26px" height="26px">
        </div>

        <div style="display: inline-block;margin-right: 25px;">
            <p>{{mesh.gravityX | number : '1.2-2'}}, {{mesh.gravityY | number : '1.2-2' }}, {{mesh.gravityZ | number : '1.2-2'}}</p>
        </div>
    </div> -->

  <div tooltip="Mesh size [mm]" style="display: inline-block">
    <div style="display: inline-block; margin-right: 5px">
      <img src="assets/mesh.png" alt="axis" width="26px" height="26px" />
    </div>

    <div style="display: inline-block; margin-right: 25px">
      <p>{{ mesh.hCoarse }}</p>
    </div>
  </div>

  <div tooltip="Refinement level" style="display: inline-block">
    <div style="display: inline-block; margin-right: 5px">
      <img src="assets/refinement_lvl.png" alt="axis" width="30px" height="26px" />
    </div>

    <div style="display: inline-block">
      <p>{{ mesh.maxSurfaceRefinementLevel }}</p>
    </div>
  </div>
</div>
